import { collapsedAtom } from '@/layouts/BasicLayout/store';
import { Layout } from '@arco-design/web-react';
import styled from '@emotion/styled';
import { useAtom } from 'jotai';
import React from 'react';
import { CollapseBtn } from './CollapseBtn';
import { NavMenus } from './NavMenu';

const { Sider } = Layout;
const LayoutSiderWrapper = styled(Sider)`
  position: fixed;
  height: 100%;
  padding-top: 60px;
  left: 0;
  z-index: 99;
  box-sizing: border-box;

  ::-webkit-scrollbar {
    width: 12px;
    height: 4px;
  }

  ::-webkit-scrollbar-thumb {
    border: 4px solid transparent;
    background-clip: padding-box;
    border-radius: 7px;
    background-color: var(--color-text-4);
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: var(--color-text-3);
  }

  // border
  &::after {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    right: -1px;
    width: 1px;
    height: 100%;
    background-color: var(--color-border);
  }

  > :global(.arco-layout-sider-children) {
    overflow-y: hidden;
  }
`;

export function LayoutSider() {
  const [collapsed, setCollapsed] = useAtom(collapsedAtom);
  return (
    <LayoutSiderWrapper
      collapsible
      width={collapsed ? 48 : 220} // 48 220
      trigger={null}
      collapsed={collapsed}
      onCollapse={(v) => setCollapsed(!v)}
      breakpoint="xl"
    >
      {/*导航*/}
      <NavMenus />
      <CollapseBtn />
    </LayoutSiderWrapper>
  );
}
